export default {
  'apply.form.rule.wx': 'Please add WeChat to get application eligibility',
  'apply.form.label.wx': 'WeChat ID',
  'apply.form.placeholder.wx': 'Please enter your WeChat ID',

  'apply.form.research.intro': 'Your Research Introduction',
  'apply.form.research.intro.placeholder': 'Please enter your research introduction',
  'apply.form.research.intro.max': 'Please enter a research introduction not exceeding 1000 characters',
  'apply.form.research.intro.required': 'Please enter a research introduction',
  'apply.form.professing.option1': 'Large Model Developer',
  'apply.form.professing.option2': 'Application Developer',
  'apply.form.professing.option3': 'Data Service Provider',
  'apply.form.professing.option4': 'Researcher',
  'apply.form.professing.option5': 'Other (Fill in)',

  'apply.form.hasCoverNeeds': 'Does it meet your research needs?',
  'apply.form.hasCoverNeeds.option1': 'Yes',
  'apply.form.hasCoverNeeds.option2': 'No',

  'apply.form.improve': 'Do you have any improvement suggestions or data requirements for the "Wanjuan Silk Road" multilingual multimodal corpus?',
  'apply.form.improve.placeholder': 'Please enter your suggestions or data requirements',

  'apply.form.useFor': 'Expected outcomes from using the data',
  'apply.form.useFor.placeholder': 'Please enter the expected outcomes from using the data',

  'wuanjuanPurposeOptions.option1': 'Language Model Fine-tuning and Performance Optimization',
  'wuanjuanPurposeOptions.option2': 'Voice Intelligent Assistant Application Development',
  'wuanjuanPurposeOptions.option3': 'Cross-language Enterprise Global Expansion Tool Development',
  'wuanjuanPurposeOptions.option4': 'Low-resource Language LLM Evaluation and Optimization Research',
  'wuanjuanPurposeOptions.option5': 'Low-resource Language Corpus Construction and Sharing',
  'wuanjuanPurposeOptions.option6': 'Low-resource Language Dialogue Model Alignment Benchmark Development',
  'wuanjuanPurposeOptions.option7': 'Multilingual Corpus Automatic Annotation and Generation Tool Development',
  'wuanjuanPurposeOptions.option8': 'Multilingual Intelligent Education System Research and Development',
  'wuanjuanPurposeOptions.option9': 'Other',
};